import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import * as _ from "lodash"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Circular_Search_Fields: { [id:string]: ISearchProviderField } = {
    CIRCULAR_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Circular Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    PRODUCT:                {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product', columnResourceName: 'colProduct', alignment: HorizAlignment.Left, dateFormat: "MM-dd-yy"}, domainOptions: { maxLength: 256}},
    BRAND:                  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Brand', columnResourceName: 'colBrand', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    OFFER:                  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Offer', columnResourceName: 'colOffer', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    OFFER_TYPE:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Offer Type', columnResourceName: 'colOfferType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SALES_START_DT:         {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Sales Start Date', columnResourceName: 'colSalesStartDt', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SALES_END_DT:           {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Sales End Date', columnResourceName: 'colSalesEndDt', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    AD_PRICE:               {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Ad Price', columnResourceName: 'colAdPrice', alignment: HorizAlignment.Left, numberFormat: "#,##0.00"}, domainOptions: { maxLength: 256}},
    CATEGORY:               {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Category', columnResourceName: 'colCategory', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    RETAILER:               {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Retailer', columnResourceName: 'colRetailer', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var CircularSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:     'WB_CIRCULAR_ID',
        id_ui:  'CIRCULAR_ID',
        name:   'CIRCULAR_ID'
    },

    searchProviderFields: vUI_Circular_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Circular_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    },

}


var CircularSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Retailer, Product, Brand, Category",
    renderOptions: { ui5ResourceId: "CircularSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Retailer',        searchProviderFieldId: 'RETAILER',       renderOptions: { }},
        {profileFilterName: 'Product',         searchProviderFieldId: 'PRODUCT',        renderOptions: { }},
        {profileFilterName: 'Brand',           searchProviderFieldId: 'BRAND',          renderOptions: { }},
        {profileFilterName: 'Category',        searchProviderFieldId: 'CATEGORY',       renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'CIRCULAR_ID', 'PRODUCT', 'BRAND', 'OFFER', 'OFFER_TYPE', 'SALES_START_DT', 'SALES_END_DT', 'AD_PRICE', 'CATEGORY', 'RETAILER','CREATED_DTTS','MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CircularSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var CircularSearch: ISearch = {
    searchName: "Find Circular",
    renderOptions: { ui5ResourceId: "CircularSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CircularSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("", "Circular", CircularSearch, "Circular Search")

export {CircularSearch}